/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';

import {AdnSelectComponent} from './adn-select.component';

@NgModule({
  imports: [CommonModule, FormsModule, NgSelectModule],
  declarations: [AdnSelectComponent],
  exports: [AdnSelectComponent]
})
export class AdnSelectModule {
}
